import { render, staticRenderFns } from "./UpcomingLeaves.vue?vue&type=template&id=57438a2f&scoped=true&"
import script from "./UpcomingLeaves.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpcomingLeaves.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57438a2f",
  null
  
)

export default component.exports